import Typography from '~/components/Typography';

interface Props {
  description: string;
}

const PreferenceDescription = ({ description }: Props) => {
  return (
    <Typography as="p" size="sm" className="font-medium text-[#374151]">
      {description}
    </Typography>
  );
};

export default PreferenceDescription;
